/**
 * Opal & Charlie — Product Page JS
 * File: assets/oac-product.js
 *
 * Handles:
 * - Length variant selection + price update
 * - ATC button label update
 * - Shop Pay installments update
 * - Gallery thumbnail switching
 * - Accordion expand/collapse
 * - Wishlist (localStorage)
 * - Scroll-to-reviews anchor
 */

(function () {
  'use strict';

  /* ── VARIANT SELECTION ─────────────────────────────────── */

  const lengthButtons = document.querySelectorAll('.oac-option-btn');
  const selectedOptions  = {};
  const priceEl       = document.querySelector('.oac-price-block__price');
  const installEl     = document.querySelector('.oac-price-block__installments');
  const priceNoteEl   = document.querySelector('.oac-price-block__note');
  const atcBtn        = document.querySelector('.oac-btn-atc');
  const buyNowBtn     = document.querySelector('.oac-btn-buy-now');
  const variantInput  = document.querySelector('input[name="id"]');
  const optionLabel   = document.querySelector('.oac-variant-option__label span');

  // Variant data injected by Liquid as a global (see section template)
  // window.OAC_VARIANTS = [ { id, title, price, available }, ... ]

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function formatInstallments(cents) {
    const installment = Math.ceil(cents / 4 / 100 * 100) / 100;
    return 'or <strong>4 &times; $' + installment.toFixed(2) + '</strong> with <span class="oac-price-block__sp-logo">Shop Pay</span>';
  }

  function selectVariant(btn) {
    const optionNum = btn.dataset.optionNum || '1';
    document.querySelectorAll('.oac-option-btn[data-option-num="' + optionNum + '"]')
      .forEach(b => b.classList.remove('is-selected'));
    btn.classList.add('is-selected');
    selectedOptions[optionNum] = btn.dataset.optionValue;
    const variant = (window.OAC_VARIANTS || []).find(function (v) {
      return Object.keys(selectedOptions).every(function (n) {
        return v['option' + n] === selectedOptions[n];
      });
    });
    const variantId = variant ? String(variant.id) : null;
    if (!variant) return;

    // Update hidden input (triggers Shopify cart)
    if (variantInput) variantInput.value = variantId;

    //Update ID in form
    const form = btn.closest('.oac-product-form');
    if(form){
      form.querySelector('[name="id"]').value = variantId
    }

    // Update price
    if (priceEl) {
      priceEl.innerHTML = formatMoney(variant.price) +
        '<span class="oac-price-block__note">&nbsp;· ' + variant.title + ' selected</span>';
    }
    
    // Update installments
    if (installEl) {
      installEl.innerHTML = formatInstallments(variant.price);
    }

    // Update ATC label
    if (atcBtn) {
      atcBtn.textContent = variant.available
        ? 'Add to Cart — ' + variant.title
        : 'Sold Out — ' + variant.title;
      atcBtn.disabled = !variant.available;
    }

    // Update option label
    if (optionLabel) {
      optionLabel.textContent = '— ' + variant.title + ' selected';
    }

    // Update URL without reload
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url.toString());
  }

  lengthButtons.forEach(btn => {
    btn.addEventListener('click', () => selectVariant(btn));
  });

  // Auto-select variant from URL param on load
  (function autoSelectFromUrl() {
    const params    = new URLSearchParams(window.location.search);
    const variantId = params.get('variant');
    if (!variantId) return;
    const v = (window.OAC_VARIANTS || []).find(function (vv) { return String(vv.id) === String(variantId); });
    if (v) {
      const btn1 = document.querySelector('.oac-option-btn[data-option-num="1"][data-option-value="' + v.option1 + '"]');
      if (btn1) selectVariant(btn1);
      const btn2 = document.querySelector('.oac-option-btn[data-option-num="2"][data-option-value="' + v.option2 + '"]');
      if (btn2) selectVariant(btn2);
    }
  })();


  /* ---- Quantity Inputs ---- */
  document.querySelectorAll('.oac-quantity-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = document.getElementById('oac-quantity');
      const current = parseInt(input.value, 10) || 1;
      if (btn.classList.contains('oac-quantity-btn--minus')) {
        if (current > 1) input.value = current - 1;
      } else {
        input.value = current + 1;
      }
    });
  });


  /* ── GALLERY ────────────────────────────────────────────── */

  const mainImage  = document.querySelector('.oac-gallery__main img');
  const thumbBtns  = document.querySelectorAll('.oac-gallery__thumb');

  thumbBtns.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.dataset.src;
      const alt = thumb.dataset.alt || '';

      if (!src || !mainImage) return;

      thumbBtns.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');

      mainImage.classList.add('is-loading');
      const newImg = new Image();
      newImg.onload = () => {
        mainImage.src    = src;
        mainImage.srcset = thumb.dataset.srcset || '';
        mainImage.alt    = alt;
        mainImage.classList.remove('is-loading');
      };
      newImg.src = src;
    });
  });


  /* ── ACCORDIONS ─────────────────────────────────────────── */

  const triggers = document.querySelectorAll('.oac-accordion-trigger');

  triggers.forEach(trigger => {
    // First accordion starts open
    const body = trigger.nextElementSibling;
    if (!body) return;

    const isFirst = trigger.closest('.oac-accordion-item') ===
      document.querySelector('.oac-accordion-item');

    if (isFirst) {
      trigger.setAttribute('aria-expanded', 'true');
      body.classList.add('is-open');
      trigger.querySelector('.oac-accordion-trigger__icon').textContent = '−';
    } else {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.querySelector('.oac-accordion-trigger__icon').textContent = '+';
    }

    trigger.addEventListener('click', () => {
      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!expanded));
      body.classList.toggle('is-open', !expanded);
      trigger.querySelector('.oac-accordion-trigger__icon').textContent = !expanded ? '−' : '+';
    });
  });


  /* ── WISHLIST ────────────────────────────────────────────── */

  const wishlistBtn     = document.querySelector('.oac-btn-wishlist');
  const WISHLIST_KEY    = 'oac_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
    catch { return []; }
  }

  function saveWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); }
    catch { /* localStorage unavailable */ }
  }

  if (wishlistBtn) {
    const productId = wishlistBtn.dataset.productId;

    function updateWishlistLabel() {
      const inList = getWishlist().includes(productId);
      wishlistBtn.textContent = inList ? '♥ \u00a0Saved' : '♡ \u00a0Save for later';
      wishlistBtn.style.color = inList ? 'var(--oac-pomp)' : '';
    }

    updateWishlistLabel();

    wishlistBtn.addEventListener('click', () => {
      const list  = getWishlist();
      const index = list.indexOf(productId);
      if (index > -1) {
        list.splice(index, 1);
      } else {
        list.push(productId);
      }
      saveWishlist(list);
      updateWishlistLabel();
    });
  }


  /* ── SCROLL TO REVIEWS ───────────────────────────────────── */

  const reviewLink = document.querySelector('a[href="#reviews"]');
  const ugcSection = document.getElementById('oac-ugc');

  if (reviewLink && ugcSection) {
    reviewLink.addEventListener('click', e => {
      e.preventDefault();
      ugcSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }


  /* ── BUY NOW (accelerated checkout) ─────────────────────── */
  // Dawn handles accelerated checkout natively via payment-button component.
  // The .oac-btn-buy-now button submits the form with the ?payment=shopify_pay param.

  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', () => {
      const form = document.querySelector('.oac-product-form');
      if (!form) return;

      // Create a hidden input to signal accelerated checkout
      const input   = document.createElement('input');
      input.type    = 'hidden';
      input.name    = 'return_to';
      input.value   = '/checkout';
      form.appendChild(input);
      form.submit();
    });
  }

})();
